

import { initializeSocket } from './socket';

let socket = null;

export function createSocket() {
  const token = localStorage.getItem('TOKEN');
  const sessionId = localStorage.getItem('sessionId');

  if (!token) {
    console.warn(' No token found, cannot create socket connection');
    return null;
  }
  const authPayload = {
    token,
    sessionId,
    from: 'app-fe'
  };

  socket = initializeSocket(authPayload);
  return socket;
}

export function getSocket() {
  return socket;
}

